import type { ListModelsResponse } from '@bhops/shared';
import { apiClient } from './client';

export const modelsApi = {
  async list(): Promise<ListModelsResponse> {
    const { data } = await apiClient.get<ListModelsResponse>('/models');
    return data;
  },
};
